import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { X, Globe } from "lucide-react";
import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export const TranslationPromptBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("translation_prompt_dismissed");
    const browserLang = navigator.language || (navigator.languages && navigator.languages[0]);
    const isAmharic = browserLang?.toLowerCase().includes("am");

    if (!dismissed && isAmharic) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem("translation_prompt_dismissed", "true");
    setIsVisible(false);
  };

  const handleShowHow = () => {
    setShowDialog(true);
  };

  if (!isVisible) return null;

  return (
    <>
      <Alert className="mx-4 mt-4 border-blue-500/50 bg-blue-50 dark:bg-blue-950/20">
        <Globe className="h-4 w-4 text-blue-600 dark:text-blue-400" />
        <AlertDescription>
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="space-y-1">
              <p className="text-sm font-medium text-foreground">
                Would you like to translate this page to Amharic?
              </p>
              <p className="text-sm text-muted-foreground">ይህን ገጽ ወደ አማርኛ መተርጎም ይፈልጋሉ?</p>
            </div>
            <div className="flex items-center gap-2">
              <Button size="sm" onClick={handleShowHow} className="shrink-0">
                Show Me How
              </Button>
              <Button
                size="sm"
                variant="ghost"
                onClick={handleDismiss}
                className="shrink-0"
                aria-label="Dismiss translation prompt"
              >
                <X className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </AlertDescription>
      </Alert>

      {/* Translation Instructions Dialog */}
      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <Globe className="h-5 w-5" />
              How to Translate to Amharic
            </DialogTitle>
            <DialogDescription>
              Your browser has built-in translation. Here's how to use it:
            </DialogDescription>
          </DialogHeader>

          <div className="space-y-4 py-4">
            <div className="space-y-2">
              <h4 className="font-semibold text-sm">Chrome / Edge:</h4>
              <p className="text-sm text-muted-foreground">
                1. Look for the translate icon 🌐 in your address bar (top right)
                <br />
                2. Click it and select "Amharic (አማርኛ)"
                <br />
                3. The page will translate automatically
              </p>
            </div>

            <div className="space-y-2 border-t pt-4">
              <h4 className="font-semibold text-sm">Alternative Method:</h4>
              <p className="text-sm text-muted-foreground">
                Right-click anywhere on this page and select "Translate to Amharic"
              </p>
            </div>

            <div className="space-y-2 border-t pt-4">
              <h4 className="font-semibold text-sm">Mobile:</h4>
              <p className="text-sm text-muted-foreground">
                A translation banner may appear at the bottom of your screen. Tap "Translate" and
                choose Amharic.
              </p>
            </div>
          </div>

          <Button onClick={() => setShowDialog(false)} className="w-full">
            Got It
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
